import downloadFile from '@/helpers/download-file'
import {calcPercentFromSum, calcSumFromPercent, loadTimeFields, saveTimeFields} from "@/helpers/lot-helpers";
import common from './common';

export default {
    namespaced: true,
    state: {
        ...common.state,
    },
    mutations: {
        ...common.mutations,
    },
    actions: {
        ...common.actions,
        fetchLot: ({commit, dispatch}, id) => {
            commit("removeError");
            commit("loadingProcess");
            commit("setData", {
                id
            });

            return dispatch('fetchLotInternal', id)
            .finally(() => commit("loadingCompleted"));
        },

        fetchRequests: ({commit, state, dispatch}) => {
            commit("loadingRequests");
            const id = state.data.id
            return dispatch('fetchLotInternal', id)
            .finally(() => commit("loadingRequests", false));
        },

        updateLotInfo: ({commit, dispatch, state}, data) => {
            commit("updateData", data)
        },
        fetchLotInternal: ({ commit }, id) => {
            return axios
                .get(`organizer/lots/${id}`)
                .then(res => {
                    loadTimeFields(res.data.success)
                    commit("setData", res.data.success ?? {});
                    commit("setCanUpdate", res.data?.success?.can_update ?? false);
                    commit("setLotRequestLogs", res.data.success?.lot_request_logs ?? []);
                    commit("setLotDocuments", res.data.lotDocuments ?? []);
                    commit("setLotRequests", res.data.success?.lot_requests ?? []);
                    commit("removeError");
                })
                .catch(err => {
                    commit("setError", err.response?.data?.message ?? err.message ?? "Неизвестная ошибка");
                })
        },
        create: ({commit}, formData) => {
            commit("loadingProcess");

            const data = {...formData}
            saveTimeFields(data)

            if (Number(data['percent_deposit_price']) === 1) {
                data['deposit_price'] = calcSumFromPercent(data['start_price'], data['deposit_price'])
            }
            if (Number(data['percent_step']) === 1) {
                data['step'] = calcSumFromPercent(data['start_price'], data['step'])
            }
            return axios
                .post("/organizer/lots", data)
                .then(res => {
                    commit("setData", res.data.success);
                    commit("removeError");
                    commit("setSaveError", null)
                })
                .catch(err => {
                    let errors;
                    if(err.response?.data?.errors) {
                        errors = Object.values(err.response?.data?.errors).flat();
                    }
                    commit("setSaveError", errors || err.response?.data?.message || err.message || "Неизвестная ошибка");
                })
                .finally(() => commit("loadingCompleted"));
        },
        update: ({ commit, dispatch, state }, formData) => {
            commit("loadingProcess");
            commit("setSaveError", null);

            const data = {...formData}
            saveTimeFields(data)

            if (Number(data['percent_deposit_price']) === 1) {
                data['deposit_price'] = calcSumFromPercent(data['start_price'], data['deposit_price'])
            }
            if (Number(data['percent_step']) === 1) {
                data['step'] = calcSumFromPercent(data['start_price'], data['step'])
            }
            let url = "/organizer/lots/" + state.data.id;
            return axios
                .put(url, data)
                .then(res => {
                    return dispatch("fetchLot", state.data.id);
                })
                .catch(err => {
                    let errors;
                    if(err.response?.data?.errors) {
                        errors = Object.values(err.response?.data?.errors).flat();
                    }
                    throw errors || err.response?.data?.message || err.message || "Неизвестная ошибка";
                })
                .finally(() => commit("loadingCompleted"));
        },
        allowUser: ({ commit, dispatch, state }, uid) => {
            commit("loadingRequests");
            const url = `/organizer/lots/${state.data.id}/allowUser`;
            return axios
                .put(url, { id: uid })
                .then(res => {
                    commit("setRequestActionStatus", res.data.status);
                    dispatch("fetchRequests");
                })
                .finally(() => commit("loadingRequests", false));
        },
        /** data = {id: userId, reason: text} */
        disallowUser: ({ commit, dispatch, state }, data) => {
            commit("loadingRequests");
            const url = `/organizer/lots/${state.data.id}/disallowUser`;
            return axios
                .put(url, data)
                .then(res => {
                    commit("setRequestActionStatus", res.data.status);
                    dispatch("fetchRequests");
                })
                .finally(() => commit("loadingRequests", false));
        },

        fetchRequestFiles: ({ commit, state }, userId) => {
            return axios
                .get(`/organizer/lots/${state.data.id}/${userId}/files`)
                .then(res => {
                    commit("setLotRequestFiles", res.data.success);
                })
                .catch(err => {
                    commit("setError", err.response.data.message ?? e.message ?? "Неизвестная ошибка");
                });
        },

        fetchRequestPriceOffer: async ({commit, state}, userId) => {
            commit("setLotRequestPriceOffer", null);
            try {
                const res = await axios.get(`organizer/lots/${state.data.id}/${userId}/priceOffer`)
                commit("setLotRequestPriceOffer", res.data.success);
            } catch (err) {
                commit("setError", err.response.data.message ?? e.message ?? "Неизвестная ошибка");
            }
        },

        downloadRequestFile: ({ commit, state }, data) => {
            const { userId, fileId, token } = data;
            const url = `/api/organizer/lots/${state.data.id}/${userId}/files/${fileId}`;
            downloadFile(url, token);
        },
        generateLotRequestReport: ({ commit, state, dispatch }, data) => {
            commit("loadingRequests");
            const url = `/organizer/lots/${state.data.id}/generateRequestReport`;
            return axios
                .put(url, data)
                .then(() => {
                    dispatch("fetchRequests");
                })
                .catch(err => {
                    console.log(err.response?.data?.message ?? err.message ?? "Неизвестная ошибка");
                })
                .finally(() => commit("loadingRequests", false));
        },

        downloadLotRequestReport: ({ commit, state }, data) => {
            const url = `/api/organizer/lots/${state.data.id}/downloadRequestReport`;
            downloadFile(url, data.token);
        },

        uploadLotRequestReport: ({ commit, state, dispatch }, data) => {
            commit("loadingRequests");
            const url = `/organizer/lots/${state.data.id}/uploadRequestReport`;
            const config = {
                headers: { "Content-Type": "multipart/form-data" },
            };
            const formData = new FormData();
            formData.set("attachment", data.attachment);
            formData.set("sign", data.sign);
            return axios
                .post(url, formData, config)
                .then(() => {
                    dispatch("fetchRequests");
                })
                .finally(() => commit("loadingRequests", false));
        },
    },
};
